import React, { Component } from 'react';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow.tsx';
import { LenderSelect } from '../components/LenderSelect.tsx';
import { BerSelect } from '../components/BerSelect.tsx';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    updateLead(props: any): void;
    title: any;
    subtitle?: any;
    currentLender?: string;
    currentBER?: string;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    currentLender?: string;
    currentBER?: string;
}

export class CurrentLender extends Component<IProps, IState> {
    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false, currentBER: this.props.currentBER, currentLender: this.props.currentLender};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep() {
        if (!this.state.currentLender || !this.state.currentBER) {
            var errors:string[]=[];
            if (!this.state.currentLender) {
                errors.push("Current lender is required");
            }
            if (!this.state.currentBER) {
                errors.push("Building Energy Rating is required");
            }
            this.setState({errors: errors, hasError: true});
            return;
        }
        this.props.nextStep();
    }
    
    render() {
        return (
            <header className="App-header">
                <h1 className='l'>{this.props.title}</h1>
                {this.props.subtitle && <p>{this.props.subtitle}</p>}
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <div className='justify-c' style={{maxWidth: 390}}>
                                <LenderSelect
                                    key='lenders'
                                    classes={this.state.hasError && !this.state.currentLender ? "e" : ""}
                                    label={<>Who is your current lender?</>}
                                    selectedlender={this.props.currentLender}
                                    onChange={(e) => { this.setState({currentLender: e.target.value}); this.props.updateLead({currentLender:e.target.value}); }} />
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            <div className='justify-c' style={{maxWidth: 390}}>
                                <BerSelect
                                    key='ber'
                                    classes={this.state.hasError && !this.state.currentBER ? "e" : ""}
                                    label={<>What is your Home's Building Energy Rating?</>}
                                    selectedber={this.props.currentBER}
                                    onChange={(e) => {this.setState({currentBER: e.target.value}); this.props.updateLead({ber:e.target.value})}} />
                            </div>
                        </div>
                    </div>
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header>
        );
    }
}
